var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.30957C12.5 2.75729 12.0523 2.30957 11.5 2.30957C10.9477 2.30957 10.5 2.75729 10.5 3.30957V10.3096H3.5C2.94772 10.3096 2.5 10.7573 2.5 11.3096C2.5 11.8619 2.94772 12.3096 3.5 12.3096H10.5V19.3096C10.5 19.8619 10.9477 20.3096 11.5 20.3096C12.0523 20.3096 12.5 19.8619 12.5 19.3096V12.3096H19.5C20.0523 12.3096 20.5 11.8619 20.5 11.3096C20.5 10.7573 20.0523 10.3096 19.5 10.3096H12.5V3.30957Z",
    fill: "#4D8AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.c5a223cd3013431a2d88fb0028cb6182.svg";
export { ForwardRef as ReactComponent };